module.exports = __webpack_public_path__ + "JEEP-logo.png";